import BoardDetail from "./BoardDetail";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";

function Board() {
  return (
    <>
      <Navbar />
      <BoardDetail />
      <Footer />
    </>
  );
}

export default Board;
